(async () => {
  const { Core } = await importModule('Core');
  const { Swiper } = await importModule('Swiper');

  customElements.define(
    'slideshow-inline',
    class extends Core {
      defaultProps = {
        gap: window.gutterWidth,
        slidesPerView: 4,
      };

      elements = {
        swiper: '[data-swiper]',
        pagination: '[data-pagination]',
        buttonPrev: '[data-button-prev]',
        buttonNext: '[data-button-next]',
      };

      render() {
        this._setSwiperProps();
        this._initSwiper();
        this._setSwiperPadding();
        this._setSwiperButtonsPosition();

         window.addEventListener("resize", (event) => {
              
              this._setSwiperPadding();
               this._setSwiperButtonsPosition();

                if(this.withOffset) {
                this.swiperProps.slidesOffsetBefore = this.offset;
                this.swiperProps.slidesOffsetAfter = this.offset;
               }
              if(this.$pagination) {
                if(this.withOffset) {
                    this.$pagination.style.setProperty('--offset', `${this.offset}px`);
                } else {
                    this.swiperPadding && this.$pagination.style.setProperty('--offset', `${this.swiperPadding}px`);
                }
            }
              
            });
        
      }

      _initSwiper() {
        this.swiper = new Swiper(this.$swiper, this.swiperProps);
        this._applyTabIndexToSlides();
        this.swiper.on('slideChange', () =>
          this._applyTabIndexToSlides()
        );
      }

      _isLastVisibleSlide(index) {
        const visibleSlidesIndices =
          this.swiper.activeIndex + this.swiper.params.slidesPerView;
        const isLastSlide =
          index ===
          this.$swiper.querySelectorAll('.swiper-slide').length - 1;
        // Return false if it's the last slide
        return isLastSlide ? false : index >= visibleSlidesIndices;
      }

      _applyTabIndexToSlides() {
        const slides = this.$swiper.querySelectorAll('.swiper-slide');
        slides.forEach((slide, index) => {
          slide.setAttribute('tabindex', '0');
          slide.addEventListener('focus', () => {
            // If it's the first slide, slide to the start of the carousel.
            if (index === 0) {
              this.swiper.slideTo(0);
            }
            // If it's the last visible slide, slide to the next.
            else if (this._isLastVisibleSlide(index)) {
              this.swiper.slideNext();
              // After sliding to the next set, set the focus to the first slide in the next set
              const nextSlide = slides[this.swiper.activeIndex];
              if (nextSlide) {
                nextSlide.focus();
              }
            }
            // If it's the last slide, set its tabindex to -1 after it loses focus
            if (index === slides.length - 1) {
              slide.addEventListener('blur', () => {
                slide.setAttribute('tabindex', '-1');
              });
            }
          });
        });
      }

      _setSwiperProps() {
        this.swiperProps = {
          loop: this.withLoop,
          watchSlidesProgress: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          breakpoints: {
            1: {
              slidesPerView: 1.5,
              spaceBetween: this.gap,
            },
            992: {
              slidesPerView: this.slidesPerView,
              spaceBetween: this.gap,
            },
          },
        };
        if (this.withOffset) {
          this.swiperProps.slidesOffsetBefore = this.offset;
          this.swiperProps.slidesOffsetAfter = this.offset;
        }
        if (this.$pagination) {
          this.swiperProps.pagination = {
            el: this.$pagination,
            type: 'bullets',
            clickable: true,
          };
          if (this.withOffset) {
            this.$pagination.style.setProperty(
              '--offset',
              `${this.offset}px`
            );
          } else {
            this.swiperPadding &&
              this.$pagination.style.setProperty(
                '--offset',
                `${this.swiperPadding}px`
              );
          }
        }
      }

      _setSwiperButtonsPosition() {
        this.swiperPadding &&
          this.$swiper.style.setProperty(
            '--button-position',
            this.swiperPadding - this.navButtonWidth / 2 + 'px'
          );
      }

      _setSwiperPadding() {
        if (this.swiperPadding) {
          this.$swiper.style.paddingLeft = this.swiperPadding + 'px';
          this.$swiper.style.paddingRight = this.swiperPadding + 'px';
        }
        return;
      }

      get slidesPerView() {
        return (
          (this.getAttribute('slides-per-view') &&
            +this.getAttribute('slides-per-view')) ||
          this.defaultProps.slidesPerView
        );
      }
      get slidesCount() {
        return this.getAttribute('slides-count');
      }
      get gap() {
        return (
          (this.getAttribute('gap') && +this.getAttribute('gap')) ||
          this.defaultProps.gap
        );
      }
      get withOffset() {
        return this.hasAttribute('offset');
      }
      get withLoop() {
        return (
          this.hasAttribute('loop') &&
          this.slidesCount > this.slidesPerView
        );
      }
      get slidesCount() {
        return Number(
          this.getAttribute('slides-count') ||
            this.querySelectorAll('.swiper-slide').length
        );
      }
      get offset() {
        return (
          (document.documentElement.offsetWidth -
            window.containerInnerWidth) /
          2
        );
      }

      get swiperPadding() {
        return (
          this.hasAttribute('container') &&
          (document.documentElement.offsetWidth -
            window.containerInnerWidth) /
            2
        );
      }

      get navButtonWidth() {
        return this.$buttonNext.offsetWidth;
      }
    }
  );
})();
